import { render, staticRenderFns } from "./WorkingGroupCreateOrUpdate.vue?vue&type=template&id=0368e83b&"
import script from "./WorkingGroupCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./WorkingGroupCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports